import { render, staticRenderFns } from "./ConfirmPurchasing.vue?vue&type=template&id=c251eb20&"
import script from "./ConfirmPurchasing.vue?vue&type=script&lang=js&"
export * from "./ConfirmPurchasing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports